import React from 'react';
import { startCase } from 'lodash';
import { Card, Typography } from 'ui-kit';
import { tableData } from './features';
import './PlanDetails.scss';
import { PaymentPlan } from 'api/types/owner';

const getLabel = (tableHeader: string) => {
  return startCase(tableHeader);
};

export default function PlanDetails() {
  return (
    <div className="PlanDetailsTable">
      <Typography variant="h5">Features</Typography>
      {Object.entries(tableData).map(([key, values], index) => (
        <Card className="PlanDetailsTable-section" key={index}>
          <tr className="PlanDetailsTable-section-header-row">
            <th className="PlanDetailsTable-section-header-row-table-name">
              <Typography variant="body1">{getLabel(key)}</Typography>
            </th>
            <th>
              <Typography variant="body1">Basic</Typography>
            </th>
            <th>
              <Typography variant="body1">Pro</Typography>
            </th>
            <th>
              <Typography variant="body1">Pro Plus</Typography>
            </th>
            <th>
              <Typography variant="body1">Enterprise</Typography>
            </th>
          </tr>
          {values.map((value, index) => (
            <tr key={index} className="PlanDetailsTable-section-row">
              <td className="PlanDetailsTable-section-row-feature-name">
                <Typography variant="body1">
                  {value.featureName}&nbsp;
                  {value.featureIcon ? value.featureIcon : null}
                </Typography>
              </td>
              <td>
                <Typography variant="body2">{value[PaymentPlan.Basic]}</Typography>
              </td>
              <td>
                <Typography variant="body2">{value[PaymentPlan.Pro]}</Typography>
              </td>
              <td>
                <Typography variant="body2">{value[PaymentPlan.ProPlus]}</Typography>
              </td>
              <td>
                <Typography variant="body2">{value[PaymentPlan.Enterprise]}</Typography>
              </td>
            </tr>
          ))}
        </Card>
      ))}
    </div>
  );
}
